<template>
  <div class="weui-tabs">
    <div class="weui-tabs-bar__wrp">
      <div style="height: 100%">
        <div class="weui-tabs-bar__content" id="tab-scroll">
          <div v-for="(item, index) in tabs" :key="index" :id="'item_' + index">
            <div
              class="weui-tabs-bar__item"
              :style="{
                backgroundColor: tabBackgroundColor,
                color:
                  activeTab == index ? tabActiveTextColor : tabInactiveTextColor
              }"
              @click="handleTabClick(index)"
            >
              <div
                class="top-nav-item"
                :class="[
                  tabClass,
                  activeTab === index ? 'top-nav-item-active' : ''
                ]"
                :style="{
                  borderBottomColor:
                    activeTab === index ? tabUnderlineColor : 'transparent'
                }"
              >
                <span class="">{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tabs: { type: Array, default: () => [] },
    tabClass: { type: String, default: '' },
    swiperClass: { type: String, default: '' },
    activeClass: { type: String, default: '' },
    tabUnderlineColor: { type: String, default: '#07c160' },
    tabActiveTextColor: { type: String, default: '#000000' },
    tabInactiveTextColor: { type: String, default: '#000000' },
    tabBackgroundColor: { type: String, default: '#ffffff' },
    activeTab: { type: Number, default: 0 },
    duration: { type: Number, default: 500 }
  },
  watch: {
    activeTab(_activeTab) {
      var len = this.tabs.length
      if (len === 0) return
      var currentView = _activeTab - 1
      if (currentView < 0) currentView = 0
      if (currentView > len - 1) currentView = len - 1
      this.currentView = currentView
      // document.getElementById("item_" + currentView).scrollTo(57);
    }
  },
  data() {
    return {
      currentView: 0
    }
  },
  methods: {
    handleTabClick(index) {
      this.$emit('click', index)
    }
  }
}
</script>
<style lang="scss" scoped>
.weui-tabs {
  width: 100%;
  height: 100%;
}
.scroll {
  width: 100%;
}
.weui-tabs-bar__wrp {
  width: 100%;
  height: 100%;
  background: #fff;
}

.weui-tabs-bar__content {
  width: 100%;
  height: 100%;
  display: flex;
  white-space: nowrap;
}

.weui-tabs-bar__item {
  display: inline-block;
}

.weui-tabs-bar__title {
  display: inline-block;
  border-bottom-width: 2px;
  border-bottom-style: solid;
  border-bottom-color: transparent;
}
.top-nav-item {
  font-size: 3.47vw;
  color: #979da5;
  text-align: center;
  line-height: 10.67vw;
  height: 10.67vw;
  white-space: nowrap;
  padding: 0vw 3.2vw;
}
.top-nav-item-active {
  position: relative;
  font-weight: 600;
  font-size: 5.33vw;
  color: #fa5a73;
}
/* .top-nav-item-active::after {
  content: "";
  display: block;
  width: 40rpx;
  height: 8rpx;
  position: absolute;
  bottom: 0rpx;
  left: 50%;
  background-color: rgb(228, 65, 47);
  transform: translate(-50%);
} */
</style>
